const SUCCESS_EVENTS = new Set([
  'FINISH',
  'FINISH_ONLY_WABA',
  'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING',
  'FINISH_OBO_MIGRATION',
  'FINISH_GRANT_ONLY_API_ACCESS',
]);

export function isFacebookOrigin(origin) {
  try {
    const url = new URL(origin);
    return url.protocol === 'https:' &&
      (url.hostname === 'facebook.com' || url.hostname.endsWith('.facebook.com'));
  } catch {
    return false;
  }
}

export function parseEmbeddedSignupMessage(raw) {
  let message;
  try {
    message = typeof raw === 'string' ? JSON.parse(raw) : raw;
  } catch {
    return null;
  }

  if (!message || message.type !== 'WA_EMBEDDED_SIGNUP') return null;

  if (SUCCESS_EVENTS.has(message.event)) {
    const data = message.data || {};
    if (!data.waba_id || !data.phone_number_id) {
      return {
        type: 'error',
        message: 'Meta completed the flow without returning a WhatsApp phone number. Please restart Embedded Signup.',
      };
    }
    return {
      type: 'success',
      data: {
        waba_id: data.waba_id,
        phone_number_id: data.phone_number_id,
        business_id: data.business_id || null,
      },
    };
  }

  if (message.event === 'CANCEL') {
    const data = message.data || {};
    if (data.error_message) {
      const reference = [data.error_code && `code ${data.error_code}`, data.session_id && `session ${data.session_id}`]
        .filter(Boolean).join(', ');
      return {
        type: 'error',
        message: `${data.error_message}${reference ? ` (${reference})` : ''}`,
      };
    }
    return {
      type: 'cancel',
      message: data.current_step
        ? `Setup was closed at ${data.current_step.replaceAll('_', ' ').toLowerCase()}.`
        : 'Setup was cancelled. Please try again.',
    };
  }

  if (message.event === 'ERROR') {
    return { type: 'error', message: message.data?.error_message || 'Meta could not complete setup.' };
  }

  return null;
}
